// src/lib/keycloak.ts
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL || 'https://auth.roommatik.com',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'roommatik',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'insight',
});

export default keycloak;
